var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePick',_vm._g(_vm._b({staticClass:"t-date-picker",class:[_vm.colorVariant],attrs:{"has-input-element":false,"weekdays":_vm.weekdays,"months":_vm.months,"prev-month-caption":_vm.prevMonthCaption,"next-month-caption":_vm.nextMonthCaption,"set-time-caption":_vm.setTimeCaption}},'DatePick',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }